
import { createSlice } from '@reduxjs/toolkit';

export const soundIDSlice = createSlice({
    name: 'soundID',
    initialState: {
        loading: true,
        error: false,
    },
    reducers: {
        SOUND_ID_FETCH_START: (state) => {
            state.loading = true
        },
        SOUND_ID_STOP: (state) => {
            state.loading = false
        },
  
    }
});

export const { SOUND_ID_FETCH_START,SOUND_ID_STOP } = soundIDSlice.actions;
export default soundIDSlice.reducer;